import { Switch } from "@mui/material";
import styled from "styled-components";

import { rydeColors } from "@ryde/theme";

export const AdditionSwitch = styled(Switch)`
  width: 28px;
  height: 16px;
  padding: 0;
  display: flex;

  &:active {
    .MuiSwitch-thumb {
      width: 15px;
    }
    .MuiSwitch-switchBase.Mui-checked {
      transform: translateX(9px);
    }
  }

  .MuiSwitch-switchBase {
    padding: 2px;

    &.Mui-checked {
      transform: translateX(12px);
      color: ${rydeColors.white};

      + .MuiSwitch-track {
        opacity: 1;
        background-color: ${rydeColors.additionsSwitchBgColor};
      }
    }
  }

  .MuiSwitch-thumb {
    box-shadow: 0 2px 4px 0 rgb(0 35 11 / 20%);
    width: 12px;
    height: 12px;
    border-radius: 6px;
  }

  .MuiSwitch-track {
    border-radius: 8px;
    opacity: 1;
    background-color: ${rydeColors.additionsSwitchBgColor};
    box-sizing: border-box;
  }
`;
